import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type ModalState = {
  data: React.ReactNode;
  isOpen: boolean;
  modalClassNames: string;
  modalStyles: object;
  withOverlay: boolean;
};

const initialState: ModalState = {
  data: "",
  isOpen: false,
  modalClassNames: "",
  modalStyles: {},
  withOverlay: true,
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    publishModalData: (state, action: PayloadAction<{ modalData: React.ReactNode }>) => {
      state.data = action.payload.modalData;
    },
    publishModalVisibility: (state, action: PayloadAction<{ isOpen: boolean }>) => {
      state.isOpen = action.payload.isOpen;
      if (!action.payload.isOpen) {
        state.data = "";
        state.modalClassNames = "";
        state.modalStyles = {};
        state.withOverlay = true;
      }
    },
    publishModalClasses: (state, action: PayloadAction<{ classNames: string }>) => {
      state.modalClassNames = action.payload.classNames;
    },
    publishModalStyles: (state, action: PayloadAction<{ cssStyles: object }>) => {
      state.modalStyles = action.payload.cssStyles;
    },
    publishModalProps: (state, action: PayloadAction<{ withOverlay: boolean }>) => {
      state.withOverlay = action.payload.withOverlay;
    },
  },
});

export const { publishModalData, publishModalVisibility, publishModalClasses, publishModalStyles, publishModalProps } =
  modalSlice.actions;

export default modalSlice.reducer;
